module.exports = __webpack_public_path__ + "img/sucess.0758827a.gif";